/* 运营计划管理
 *    计划看板
 *      计划列表 详情
 *      创建列表 CreatePlanning
 *    计划日志
 *
 */

const _path = '/operate/'

const OperateRouter: any = {
  meta: {
    title: '运营计划管理',
    icon: 'el-icon-circle-check'
  },
  children: [
    {
      path: _path + 'planning',
      component: () => import('@/views/OperateAdmin/Planning/index.vue'),
      meta: {
        title: '计划看板',
        hidden: false
      }
    },
    {
      path: _path + 'create',
      component: () => import('@/views/OperateAdmin/CreatePlanning/index.vue'),
      meta: {
        title: '新增计划',
        parentPath: _path + 'planning',
        hidden: true
      }
    },
    {
      path: _path + 'detail',
      component: () => import('@/views/OperateAdmin/PlainningDetail/index.vue'),
      meta: {
        title: '计划列表',
        parentPath: _path + 'planning',
        hidden: true
      }
    },
    {
      path: _path + 'log',
      component: () => import('@/views//OperateAdmin/Log/index.vue'),
      meta: {
        title: '计划日志',
        hidden: false
      }
    }
  ]
}

export default OperateRouter
